/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CodingQuestionSolutionEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('CODING_QUESTION_SOLUTION_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class CodingQuestionSolutionEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CodingQuestionSolutionEnabledSettingParser.decode(input).map(res => new CodingQuestionSolutionEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return CodingQuestionSolutionEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CodingQuestionSolutionEnabledSettingParser.encode(data);
    }
    static schema() {
        return CodingQuestionSolutionEnabledSettingParser.schema();
    }
}
